import { JobBoostState } from './job-boost-selectors';
import { STARTING, SUCCESS, FAILURE } from '../action/util/action-name-creators';
import { Action, updateResourceByParam } from '../reducers/utils/state-manager';

import { convertArrayToMap } from '../util/convert-array-to-map';

const InitialState: JobBoostState = {
  jobBoostsById: {},
  jobBoostsStateByJobId: {},
  jobBoostsStateByOrgId: {},
};

export const jobBoostReducer = (state = InitialState, action: Action) => {
  switch (action.type) {
    case STARTING('LOAD_JOB_BOOSTS'): {
      const { jobId } = action.payload.args;
      return updateResourceByParam(state, 'jobBoosts', 'jobId', jobId, true);
    }
    case STARTING('LOAD_JOB_BOOSTS_FOR_ORG'): {
      const { orgId } = action.payload.args;
      return updateResourceByParam(state, 'jobBoosts', 'orgId', orgId, true);
    }
    case SUCCESS('LOAD_JOB_BOOSTS'): {
      const {
        args: { jobId },
        data,
      } = action.payload;
      return updateResourceByParam(
        state,
        'jobBoosts',
        'jobId',
        jobId,
        false,
        convertArrayToMap(data, (d: JobBoost) => String(d.jobBoostId)),
      );
    }
    case SUCCESS('LOAD_JOB_BOOSTS_FOR_ORG'): {
      const {
        args: { orgId },
        data,
      } = action.payload;
      return updateResourceByParam(
        state,
        'jobBoosts',
        'orgId',
        orgId,
        false,
        convertArrayToMap(data, (d: JobBoost) => String(d.jobBoostId)),
      );
    }
    case FAILURE('LOAD_JOB_BOOSTS'): {
      const { jobId } = action.payload.args;
      return updateResourceByParam(state, 'jobBoosts', 'jobId', jobId, false);
    }
    case FAILURE('LOAD_JOB_BOOSTS_FOR_ORG'): {
      const { orgId } = action.payload.args;
      return updateResourceByParam(state, 'jobBoosts', 'orgId', orgId, false);
    }
    case SUCCESS('CREATE_JOB_BOOST'):
    case SUCCESS('UPDATE_RECURRING_JOB_BOOST'): {
      const { data } = action.payload;
      const { jobBoostId, jobId } = data;

      return updateResourceByParam(state, 'jobBoosts', 'jobId', jobId, false, {
        [jobBoostId]: data,
      });
    }
    default: {
      return state;
    }
  }
};
